import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { LOADING_CONTEXT } from '@ps/core-overlay';

import { Question } from '../models/question.model';
import { QuestionsListResponseDto } from './dtos/questions.dto';
import { QuestionsMapper } from './mappers/questions.mapper';
import { QuestionsPayloadMapper } from './mappers/questions.payload.mapper';

@Injectable({ providedIn: 'root' })
export class QuestionsApi {
  private readonly _http = inject(HttpClient);
  private readonly _env = inject(ENV_CONFIG);

  private readonly _mapper = new QuestionsMapper();
  private readonly _payloadMapper = new QuestionsPayloadMapper();

  private readonly _attributesUrl = `${this._env.pureSpectrum.url}/buyers/v3/attributes`;

  public getQuestions(
    search: string,
    categories: string,
  ): Observable<Question[]> {
    const body = this._payloadMapper.toPayload({ search, categories });
    return this._http
      .post<QuestionsListResponseDto>(`${this._attributesUrl}/list`, body, {
        context: new HttpContext().set(LOADING_CONTEXT, true),
      })
      .pipe(map((res) => this._mapper.fromDtoList(res)));
  }
}
